// images
import wabysLogo from '../../assets/wabys.png';
// react tools
import { useNavigate } from "react-router-dom";
// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCompress, faExpand, faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
// global data
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
// custom hooks
import useFullScreen from 'hooks/useFullScreen';
// utils
import fullScreen from "../../utils/fullScreen";
import { userFullName } from '../../utils/userFullName';

const PdmsNavbar = ({ children }) => {
    const navigate = useNavigate();
    const { logout, userInfo } = useAuth();
    const { language } = useLanguage();
    const isFullScreen = useFullScreen();

    return (
        <div className="h-[12vh] relative z-10">
            {/* Navbar's Content */}
            <div className="h-full flex flex-col md:flex-row items-center justify-between w-full mx-auto px-6 py-4 gap-8">
                {/* Logo */}
                <div className="flex items-center gap-6">
                    <img className={`w-[100px] md:w-[120px] lg:w-[140px] cursor-pointer`} src={wabysLogo} alt="Wabys Logo" onClick={() => navigate('/wabys')} />
                </div>
                {/* rest of navbar */}
                <div className="flex items-center gap-4 relative flex-wrap justify-evenly">
                    {children}
                    {/* Full Screen */}
                    <button
                        onClick={fullScreen}
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        title={language ? (isFullScreen ? 'Exit Full Screen' : 'Enter Full Screen') : (isFullScreen ? 'خروج من الشاشة الكاملة' : 'دخول الشاشة الكاملة')}
                    >
                        <FontAwesomeIcon
                            icon={isFullScreen ? faCompress : faExpand}
                            className="text-xl text-watomsBlue"
                        />
                    </button>
                    {/* User Name */}
                    <span className="flex items-center gap-2 font-bold text-lg md:min-w-[120px] min-w-[300px] justify-center">
                        <FontAwesomeIcon icon={faUser} className="text-watomsBlue" />
                        {userFullName(userInfo, language)}
                    </span>
                    {/* Log out */}
                    <button
                        className="rounded-full w-10 h-10 flex justify-center items-center bg-white/80 hover:bg-gray-200 shadow transition-all"
                        onClick={() => { logout(); navigate('/login'); }}
                    >
                        <FontAwesomeIcon icon={faSignOutAlt} className="text-xl text-wisdomOrange" />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PdmsNavbar;